export default __webpack_public_path__ + "static/media/herbalife2.c3196e70.jpg";